import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { DropdownModule } from 'primeng/dropdown';

import { AppComponent } from './app.component';
import { MessagingComponent } from './messaging/messaging.component';
import { FormsModule } from '@angular/forms';
import { createCustomElement } from '@angular/elements';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './login/login.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';
import { ServiceProxyModule } from '@shared/service-proxies/service-proxy.module';
import { AppInitializer } from 'src/app-initializer';
import { API_BASE_URL } from '@shared/service-proxies/service-proxies';
import { AppConsts } from '@shared/AppConsts';
import { AppSessionService } from '@shared/session/app-session.service';
import { SharedModule } from '@app/shared/shared.module';
import { InputMaskModule } from 'primeng/inputmask';
import { RadioButtonModule } from 'primeng/radiobutton';
import { NgxGpAutocompleteModule } from "@angular-magic/ngx-gp-autocomplete";
import { Loader } from '@googlemaps/js-api-loader';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { NgxBootstrapDatePickerConfigService } from 'src/ngx-bootstrap/ngx-bootstrap-datepicker-config.service';
import { environment } from 'src/environments/environment';
import { BankidSigningModalComponent } from './bankid-signing-modal/bankid-signing-modal.component';
import { LoginButtonComponent } from './login-button/login-button.component';
import { DomContentComponent } from './dom-content/dom-content.component';
const bootstrap = environment.production ? [] : [AppComponent];

@NgModule({
  declarations: [
    AppComponent,
    MessagingComponent,
    LoginComponent,
    BankidSigningModalComponent,
    LoginButtonComponent,
    DomContentComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ServiceProxyModule,
    SharedModule,
    NgxGpAutocompleteModule,
    DropdownModule,
    InputMaskModule,
    RadioButtonModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (appInitializer: AppInitializer) => appInitializer.init(),
      deps: [AppInitializer],
      multi: true
    },
    {
      provide: Loader,
      useValue: new Loader({
        apiKey: 'AIzaSyB5z9o0l4VPC34TBOJt4bxl17XMw8mYFyY',
        libraries: ['places']
      })
    },
    { provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig },
    { provide: BsLocaleService, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerLocale },
    AppSessionService
  ],
  bootstrap: [...bootstrap]
})
export class AppModule {
  constructor(injector: Injector) {
    if(!environment.production) {
      return;
    }
    const messagingWidget = createCustomElement(MessagingComponent, { injector });
    customElements.define('norwelo-messaging', messagingWidget);
    const loginWidget = createCustomElement(LoginButtonComponent, { injector });
    customElements.define('norwelo-login-button', loginWidget);
  }

  ngDoBootstrap() {} // Prevent Angular from bootstrapping an AppComponent
}
